import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { CurrencyBadge } from '@/components/currency-badge';
import { getFieldState } from '@/utils/formUtils';
import { formValidateAndSetNumber } from '@/utils/inputApi';

export default function AllowancesColumns({ form, formFields, isEdited }) {
  const { t } = useTranslation(['forms', 'tables']);

  return [
    {
      dataIndex: 'inputName',
      header: t('type', { ns: 'forms' }),
      render: (_, row) => {
        const { groupName, inputName } = row;

        const name = groupName ? [groupName, inputName] : inputName;

        const nameState = getFieldState({
          formFields,
          formKeys: name,
          isEdited,
        });

        return (
          <Form.Item
            label={row.inputLabel}
            name={name}
            className="!mb-0 whitespace-nowrap"
            labelCol={{
              className:
                '!pb-0 !h-[20px] [&_label]:!text-[13px] !whitespace-nowrap',
            }}
            rules={[
              {
                // Work from home is paid per day worked from home: no amount
                // for someone who never does (same as the profile tile).
                required: inputName !== 'workFromHomeAllowance',
                message: t('formValidation.numberField.invalid', {
                  ns: 'forms',
                }),
              },
            ]}
          >
            <Input
              min={0}
              type="number"
              step="any"
              size="small"
              className="h-7"
              placeholder={row.inputLabel}
              onChange={(e) => formValidateAndSetNumber(form, e, name, 0)}
              disabled={nameState?.disabled}
            />
          </Form.Item>
        );
      },
    },
    {
      dataIndex: 'currency',
      header: t('currency', { ns: 'forms' }),
      render: (value) => {
        return (
          <CurrencyBadge
            currency={value?.label}
            currencyCode={value?.currencyCode}
          />
        );
      },
    },
    {
      dataIndex: 'unitPart',
      header: t('unit', { ns: 'forms' }),
      render: (value) => {
        return <span className="mt-4 block">{value}</span>;
      },
    },
    {
      dataIndex: 'all',
      header: t('calculationMethod', { ns: 'forms' }),
      render: (value) => {
        return <span className="mt-4 block">{value}</span>;
      },
    },
  ];
}
